import React, { useRef, useEffect, useState } from "react";
import { Form } from "semantic-ui-react";
import classnames from "classnames";
import { Search as SearchIcon, Close } from "ceicons";
import { useDebounce } from "use-debounce/lib";

function Search(props) {
  const { isOpenSearch, setIsOpenSearch, onSearchTextChange } = props;
  const searchBoxRef = useRef(null);

  const [searchText, setSearchText] = useState("");

  const [search] = useDebounce(searchText, 300);

  useEffect(() => {
    onSearchTextChange(search);
  }, [search, onSearchTextChange]);

  return (
    <>
      <form className="header-right__search-mobile">
        <div className={classnames({ open: isOpenSearch })}>
          <Close onClick={() => setIsOpenSearch(false)} />
          <input
            type="text"
            ref={searchBoxRef}
            placeholder="Buscar"
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
          />
        </div>
        <SearchIcon
          onClick={() => {
            setIsOpenSearch(true);
            searchBoxRef.current.focus();
          }}
        />
      </form>

      <Form className="header-right__search-desktop">
        <Form.Input
          icon={<SearchIcon />}
          type="text"
          placeholder="Buscar"
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
        />
      </Form>
    </>
  );
}

export default Search;
